<div [style.position]="'relative'">
  <input
    #input
    class="password-input"
    [type]="showingPassword ? 'text' : 'password'"
    autocomplete="off"
    [class.form-error-border]="error"
    [class.with-toggle]="showHidePasswordButton"
    [attr.id]="controlId"
    [attr.aria-invalid]="error ? true : null"
    [value]="value"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (focus)="inputFocused.emit()"
    (input)="handleInput($event)" />
  <button
    *ngIf="showHidePasswordButton"
    class="base-eye"
    (click)="toggleShowHide()"
    [disabled]="disabled"
    type="button"
    [ngClass]="{ opened: showingPassword, closed: !showingPassword, error: error, disabled: disabled }"></button>
</div>
